import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';
import { LoaderCircleIcon } from 'lucide-react';

export default function MessageSkeleton(messageSkeletonProps: ComponentProps<'div'>) {
  const { className, ...props } = messageSkeletonProps;
  return (
    <div className={cn('w-full py-8', className)} {...props}>
      <LoaderCircleIcon className={'text-text-brand mx-auto size-6 animate-spin'} aria-hidden={'true'} />
    </div>
  );
}
